import React, { useRef } from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconCheckBadgeGreenCircle from "../../../../img/icons/check-badge-green-circle.svg";
import { Trans } from "../../../common/Trans";
import { strings } from "../../../localization";
import { FinancingAccountInquiry } from "../../../models/financing";
import { format } from "../../../utils/format";
import { useAppDispatch } from "../../reducers";
import { closeModal } from "../reducers";
import { openPrintWindow } from "./printing";

import styles from "./index.module.scss";

export const FinancingFullApproval = (props: {
    account: FinancingAccountInquiry;
}): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const container = useRef<HTMLDivElement | null>(null);
    const onPrint = () => {
        if (container.current) {
            openPrintWindow(container.current);
        }
    };
    return (
        <div className={styles.wrapper} ref={container}>
            <SVG className={styles.icon} src={iconCheckBadgeGreenCircle} />
            <h3 className={styles.title}>
                {t`Congratulations, you're approved.`}
            </h3>
            <p className={styles.welcome}>
                <Trans
                    fmtString={t`Please take note of or <PrintLink>print</PrintLink> your account information now. You will not have access to it again until you receive your card in the mail.`}
                    data={{
                        PrintLink: (content) => (
                            <button
                                key="1"
                                className={styles.printLink}
                                onClick={onPrint}
                            >
                                {content}
                            </button>
                        ),
                    }}
                />
            </p>
            <div className={styles.numbersWrapper}>
                <div className={styles.numbersFirstLine}>
                    <div className={styles.numbersTitle}>
                        {t`account number`}
                    </div>
                    <div className={styles.numbersData}>
                        {format.wellsFargoAccountNumber(
                            props.account.account_number,
                        )}
                    </div>
                </div>
                <div className={styles.numbersLine}>
                    <div className={styles.numbersTitle}>{t`credit limit`}</div>
                    <div className={styles.numbersData}>
                        {format.money(props.account.credit_limit)}
                    </div>
                </div>
            </div>
            <p
                dangerouslySetInnerHTML={{
                    __html: strings.get("FINANCING_WELCOME_MSG") || "",
                }}
            />
            <button
                className="button"
                onClick={(e) => {
                    e.preventDefault();
                    dispatch(closeModal());
                }}
            >
                {/* TODO(i18n): Use t tagged template: {t`Continue`} */}
                Continue
            </button>
        </div>
    );
};
